import { BlockPickerOption } from '../BlockPickerPlugin/BlockPickerOption';
export function GetRemoteImageBlockOption(onSelect) {
    return new BlockPickerOption('Image from URL', {
        iconName: 'image',
        keywords: ['image', 'url'],
        onSelect: onSelect,
    });
}
